import { defineMessages } from 'react-intl'

const scope = 'procurify.hooks.useIsStripeSunset'

export const messages = defineMessages({
  stripeSunsetHelperText: {
    id: `${scope}.stripeSunsetHelperText`,
    defaultMessage:
      'Stripe spending cards are no longer supported. Please contact Support for migration options.',
  },
})
